import React, { useState, useEffect, useRef } from 'react'
import { useQuery } from '@apollo/react-hooks'
import { Link } from 'react-router-dom'
import numeral from 'numeral'
import moment from 'moment'
import {
  Select as SelectAntd, Icon, Spin, Result, Button, Typography, Alert, Upload, message, Pagination as PaginationAnt, TimePicker as TimePickerAnt,
  DatePicker as DatePickerAnt, Input, Skeleton,
} from 'antd'
import PropTypes from 'prop-types'
import Carousel, { Modal as CarouselModal, ModalGateway } from 'react-images'
import _ from 'lodash'
import * as Konsys from './konsys-ui'
import {
  DividerStyled, TagWrapper, SummaryCardWrapper,
  CollapseContentWrapper, CollapseWrapper, CardListWrapper, CardListHeaderWrapper,
  CardListContentWrapper, TabWrapper, TabHeaderWrapper, TabTitleWrapper, TabContentWrapper,
  ListWrapper, RowSelectChildWrapper, ModalCustomized, AlertCustomized, PreviewImage,
} from './styled'
import MESSAGE from '../../constants/message'
import { theme } from '../../styles/_variables'
import { checkURLIsImage } from '../../utils/util-services'

// import {
//   P, Icon, TextLink, ReactRouterLink, Div,
//   SmallText, SmallTextLink, SmallReactRouterLink,
//   Label, Input, H3,
// } from './konsys-ui'

export const TagMobile = props => (
  <Konsys.Div display='flex' width='100px' alignItems='center' justifyContent='center' bgColor={`${props.color}33`} style={{ border: `${props.color} 1px solid`, borderRadius: 5 }}>
    <Konsys.Icon icon='fas fa-circle' color={props.color} fontSize='6px' margin='2px 6px 0 0'/>
    <Konsys.Label color={theme.color.black}>{props.text}</Konsys.Label>
  </Konsys.Div>
)

export const TextWithIcon = props => (
  <Konsys.Div {...props}>
  {
    !_.isEmpty(props.link)
      ? props.type === 'a'
        ? <Konsys.TextLink href={props.link} color={props.color}>
          {props.icon && <Konsys.Icon icon={props.icon} margin='0 8px 0 0' />}
          {props.text}
        </Konsys.TextLink>
        : <Konsys.ReactRouterLink to={props.link} color={props.color}>
          {props.icon && <Konsys.Icon icon={props.icon} margin='0 8px 0 0' />}
          {props.text}
        </Konsys.ReactRouterLink>
      : <Konsys.P bold={props.bold} color={props.color}>
        {props.icon && <Konsys.Icon icon={props.icon} margin='0 8px 0 0' color={props.color} />}
        {props.text}
      </Konsys.P>
  }
  </Konsys.Div>
)

export const TextWithIconSmall = props => (
  <Konsys.Div {...props}>
  {
    !_.isEmpty(props.link)
      ? props.type === 'a'
        ? <Konsys.SmallTextLink href={props.link} color={props.color}>
          {props.icon && <Konsys.Icon fontSize={theme.fonts.size.label} icon={props.icon} margin='0 8px 0 0' />}
          {props.text}
        </Konsys.SmallTextLink>
        : <Konsys.SmallReactRouterLink to={props.link} color={props.color}>
          {props.icon && <Konsys.Icon fontSize={theme.fonts.size.label} icon={props.icon} margin='0 8px 0 0' />}
          {props.text}
        </Konsys.SmallReactRouterLink>
      : <Konsys.SmallText bold={props.bold} color={props.color}>
        {props.icon && <Konsys.Icon fontSize={theme.fonts.size.label} icon={props.icon} margin='0 8px 0 0' color={props.color} />}
        {props.text}
      </Konsys.SmallText>
  }
  </Konsys.Div>
)

export const TextBetween = props => (
  <Konsys.Div display='flex' justifyContent='space-between' alignItems='center' margin={props.margin}>
    <TextWithIcon {...props.title}>{props.title.text}</TextWithIcon>
    <TextWithIcon textAlign='right' {...props.content} />
  </Konsys.Div>
)

export const Tag = props => (
  <TagWrapper {...props}>
    <Konsys.SmallText color={theme.color.purplishGrey}>{props.text}</Konsys.SmallText>
  </TagWrapper>
)

export const Divider = props => (
  <DividerStyled {...props} />
)

export const ComponentWithLabelLarge = props => (
  <Konsys.Div display='inline-block' {...props}>
    <Konsys.SmallText bold display='block' {...props.title}>
    {
      !_.isUndefined(props.title.icon) && <Icon margin='0 8px 0 0' icon={props.title.icon} />
    }
    {props.title.text}
    </Konsys.SmallText>
    {
      props.children
    }
  </Konsys.Div>
)

const ComponentWithLabelSmall = props => (
  <Konsys.Div display='inline-block' {...props}>
    <Konsys.Label bold display='block' {...props.title}>
    {
      (!_.isEmpty(props.title.icon) || !_.isUndefined(props.title.icon)) && <Icon margin='0 6px 0 0' fontSize='10px' icon={props.title.icon} />
    }
    {props.title.text}
    </Konsys.Label>
    {
      props.children
    }
  </Konsys.Div>
)

export const LargeTextWithLabel = props => (
  <ComponentWithLabelLarge {...props}>
  {
    _.isArray(props.content)
      ? props.content.map((v, i) => <TextWithIcon key={i} {...v}>{v.text}</TextWithIcon>)
      : <TextWithIcon {...props.content}>{props.content.text}</TextWithIcon>
  }
  </ComponentWithLabelLarge>
)

export const SmallTextWithLabel = props => (
  <ComponentWithLabelSmall {...props}>
    <TextWithIconSmall {...props.content}>{props.content.text}</TextWithIconSmall>
  </ComponentWithLabelSmall>
)

export const TextareaWithLabel = props => (
  <ComponentWithLabelLarge {...props}>
    <Konsys.Input as='textarea' rows={5} margin='8px 0 0' {...props.textarea} />
  </ComponentWithLabelLarge>
)

export const InputWithLabel = props => (
  <ComponentWithLabelLarge margin='8px 0' {...props}>
    <Konsys.Input {...props.input} onChange={e => props.onChange(e)} />
  </ComponentWithLabelLarge>
)

export const AutoCompleteWithLabel = props => (
  <ComponentWithLabelLarge margin='8px 0' {...props}>
    <SelectAntd {...props.select} showSearch={true}>
    {
      !_.isEmpty(props.select.options) && props.select.options.map((v, i) => (
        <SelectAntd.Option key={i} value={v.value} {...v}>{v.text}</SelectAntd.Option>
      ))
    }
    </SelectAntd>
  </ComponentWithLabelLarge>
)

export const DateWithLabel = props => (
  <ComponentWithLabelLarge {...props}>
    <Konsys.Input
      margin='8px 0 0'
      rule={{
        type: 'date',
      }}
      {...props.input}
    />
  </ComponentWithLabelLarge>
)

export const Select = props => (
  <SelectAntd {...props}>
  {
    !_.isEmpty(props.options) && props.options.map((v, i) => (
      <SelectAntd.Option key={i} value={v.value} {...v}>{v.text}</SelectAntd.Option>
    ))
  }
  </SelectAntd>
)

export const ImagePopUp = ({
  modalIsOpen, setModalIsOpen, images, index,
}) => (
  <ModalGateway>
  {modalIsOpen ? (
    <CarouselModal onClose={() => setModalIsOpen(!modalIsOpen)} allowFullscreen={false} styles={{
      positioner: base => ({
        ...base,
      }),
      dialog: base => ({
        ...base,
        margin: 'auto',
      }),
    }}>
      <Carousel views={images} currentIndex={index} isFullscreen={false} components={{ Footer: null }} styles={{
        container: base => ({
          ...base,
        }),
        view: base => ({
          ...base,
          height: '100vh',
          display: 'flex ',
          justifyContent: 'center',
          touchAction: 'pinch-zoom',
          '& > img': {
            maxWidth: '75%',
            margin: 'auto',
          },
        }),
      }} />
    </CarouselModal>
  ) : null}
</ModalGateway>
)

export const SelectWithLabel = props => (
  <ComponentWithLabelLarge {...props}>
    <Select {...props.select} style={{ width: 200, ...props.select.style }} options={props.select.options} />
  </ComponentWithLabelLarge>
)

export const SummaryCard = props => (
  <SummaryCardWrapper>
    <TextWithIconSmall color={theme.color.purplishGrey} bold {...props.title}>{props.title.text}</TextWithIconSmall>
    <Konsys.H3 margin='24px 0 8px -2px' bold>{props.content}</Konsys.H3>
    <Konsys.Div display='flex' alignItems='center'>
      <TextWithIconSmall text={props.subContent.percent} icon={props.subContent.type === 'up' ? 'fal fa-arrow-up' : 'fal fa-arrow-down'} bold color={props.subContent.type === 'up' ? theme.color.success : theme.color.error} />
      <TextWithIconSmall margin='0 0 0 8px' text={props.subContent.text} icon={props.subContent.icon} />
    </Konsys.Div>
  </SummaryCardWrapper>
)

export const Collapse = (props) => {
  const [isOpen, setIsOpen] = useState(props.open)
  return (
    <CollapseWrapper open={isOpen} fullHeight={props.fullHeight} minHeight={props.minHeight} {..._.omit(props, ['onClick'])}>
      <Konsys.Div
        padding='0 0 6px'
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        cursor='pointer'
        moreStyle={{ borderBottom: `1px solid ${theme.color.veryLightBlue}` }}
        onClick={() => {
          setIsOpen(!isOpen)
          if (props.onClick) {
            props.onClick()
          }
        }}
      >
        <TextWithIcon text={props.text} bold />
        <Konsys.Icon icon='fal fa-chevron-up' color={theme.color.lightBlue} />
      </Konsys.Div>
      <CollapseContentWrapper>
      {
        props.children
      }
      </CollapseContentWrapper>
    </CollapseWrapper>
  )
}

/* =============== List ================ */
export const CardList = props => (
  <CardListWrapper active={props.active} onClick={() => props.onClick()}>
    <CardListHeaderWrapper>
      <Konsys.Div display='flex' alignItems='center'>
        <Konsys.SmallText bold>{props.title}</Konsys.SmallText>
        <Konsys.Label color={theme.color.heather} margin='0 0 0 4px'>{props.label}</Konsys.Label>
      </Konsys.Div>
      {
        props.status && <Konsys.SmallText bold textAlign='right' color={props.status.color}>{props.status.text}</Konsys.SmallText>
      }
    </CardListHeaderWrapper>
    {
      !_.isEmpty(props.content) && <CardListContentWrapper fullWidth={_.isEmpty(props.content.three)}>
        <Konsys.Div>
          {
            !_.isUndefined(props.content.one) && <LargeTextWithLabel margin='0 16px 0 0' {...props.content.one} />
          }
          {
            !_.isUndefined(props.content.two) && <LargeTextWithLabel {...props.content.two} />
          }
        </Konsys.Div>
        {
          !_.isUndefined(props.content.three) && <LargeTextWithLabel {...props.content.three} />
        }
      </CardListContentWrapper>
    }
  </CardListWrapper>
)

const TabTitle = props => (
  <TabTitleWrapper active={props.active}>
    <TextWithIconSmall
      link={props.link}
      color={props.active ? theme.color.offWhite : theme.color.black}
      text={props.text}
      icon={props.icon}
      onClick={() => props.onClick()}
    />
  </TabTitleWrapper>
)

export const Tab = (props) => {
  const [currentTab, setCurrentTab] = useState(props.current || 0)
  return (
    <TabWrapper white={props.white}>
      <TabHeaderWrapper>
        <Konsys.Div>
        {
          !_.isUndefined(props.title) && !_.isEmpty(props.title) && props.title.map((v, i) => (
            <TabTitle
              link={v.link}
              active={currentTab === i}
              key={i}
              text={v.text}
              icon={v.icon}
              onClick={() => setCurrentTab(i)}
            />
          ))
        }
        {
          props.tabLoading && <Loading size='extraSmall' margin='0 0 0 16px'/>
        }
        </Konsys.Div>
        <Konsys.Div margin='0 16px 0 0'>
        {
          !_.isUndefined(props.buttonList) && !_.isEmpty(props.buttonList) && props.buttonList.map((v, i) => (
            v
          ))
        }
        </Konsys.Div>
      </TabHeaderWrapper>
      <TabContentWrapper filterHeight={props.filterHeight} fullHeight={props.fullHeight}>
      {
        props.loading
          ? <Konsys.Div>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </Konsys.Div>
          : _.isArray(props.children) ? props.children[currentTab] : props.children
      }
      </TabContentWrapper>
    </TabWrapper>
  )
}

export const FullPageContainer = props => (
  <Tab fullHeight title={props.title} buttonList={props.buttonList}>
    <Tab white loading={props.loading} title={props.detail.title} buttonList={props.detail.buttonList} current={props.detail.current}>
    {
      props.children
    }
    </Tab>
  </Tab>
)

export const CardListInTab = (props) => {
  const detectScroll = (e) => {
    if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
      props.onInfiniteScroll()
    }
  }

  return (
    <ListWrapper
      onScroll={e => detectScroll(e)}
      bgColor={!props.loading && 'white'}
      margin='0 24px 0 0'
      height='100%'
      // height={props.filterHeight ? `calc(100% - ${props.filterHeight}px)` : '100%'}
      moreStyle={{
        overflow: 'auto',
        overflowAnchor: 'auto',
      }}
    >
    {
      !_.isEmpty(props.list) && props.list.map((v, i) => (
        <CardList
          active={props.currentCard === i}
          key={i}
          {..._.omit(v, ['detail'])}
          onClick={() => props.onClick(i)}
        />
      ))
    }
    </ListWrapper>
  )
}

export const ListContainer = (props) => {
  const [currentCard, setCurrentCard] = useState(0)
  return (
    <Tab fullHeight loading={props.loading} title={props.title} buttonList={props.buttonList} tabLoading={props.tabLoading}>
      <Konsys.Div height='100%'>
        {
          props.filter
        }
        {
          props.fetchMoreLoading && <Loading style={{ display: 'block' }} margin='16px auto'/>
        }
        <Konsys.Div
          display='flex'
          alignItems='flex-start'
          height={`calc(100% - ${props.filterHeight || 58}px)`}
        >
          <Konsys.Div height='100%' moreStyle={{ overflow: 'auto', flexBasis: (_.isEmpty(props.list) || props.listLoading) ? '100%' : '80%', maxWidth: (_.isEmpty(props.list) || props.listLoading) ? '100%' : '440px' }}>
          {
            props.listLoading
              ? <Konsys.Div>
                <Skeleton active />
                <Skeleton active />
              </Konsys.Div>
              : _.isEmpty(props.list)
                ? <Konsys.Div height={`calc(100% - ${props.filterHeight || 58}px)`} width='100%' display='flex' alignItems='center' justifyContent='center'>
                  <Konsys.P color={theme.color.lightBlue}>{MESSAGE.empty.list}</Konsys.P>
                </Konsys.Div>
                : <CardListInTab
                  filterHeight={props.filterHeight || 58}
                  list={props.list}
                  currentCard={currentCard}
                  onClick={i => setCurrentCard(i)}
                  onInfiniteScroll={() => props.onInfiniteScroll()}
                />
          }
          </Konsys.Div>
          {
            !props.listLoading && !_.isEmpty(props.list)
            && <Tab tabLoading={props.detailTabLoading} filterHeight={props.filterHeight || 58} white title={props.list[currentCard].detail.title} buttonList={props.list[currentCard].detail.buttonList}>
              {
                props.list[currentCard].detail.content
              }
            </Tab>
          }
        </Konsys.Div>
      </Konsys.Div>
      {props.children}
    </Tab>
  )
}
/* =============== end List ================ */

/* =============== debt ================ */
export const DebtDetail = props => (
  <Konsys.Div width='100%'>
    <Konsys.Div>
      <LargeTextWithLabel margin='0 40px 0 0' title={{ text: 'วันที่ออกใบ' }} content={{ text: props.data.date }} />
      <LargeTextWithLabel margin='0 16px 0 0' title={{ text: 'ลูกค้า' }} content={{ text: props.data.customer }} />
      <LargeTextWithLabel title={{ text: 'ประเภทการจ่ายเงิน' }} content={{ text: props.data.paymentType }} />
    </Konsys.Div>
    <Konsys.Div display='flex' margin='16px 0 0' flexDirection={props.block ? 'column' : 'row'}>
      <Konsys.Div bgColor={theme.color.remark} padding='16px' margin={props.block ? '0' : '0 32px 0 0'} moreStyle={{ flexBasis: props.block ? '100%' : '55%' }}>
        <LargeTextWithLabel title={{ text: 'หมายเหตุ' }} content={{ text: _.isUndefined(props.data.remark) ? '-' : props.data.remark }} />
      </Konsys.Div>
      <Konsys.Div moreStyle={{ flexBasis: '35%', width: props.block ? '300px' : '35%' }} margin={props.block ? '16px 0 0' : '0'}>
        <TextBetween title={{ text: 'มูลค่าเดิม' }} content={{ text: `${numeral(props.data.oldCost).format('0,0.00')} บาท` }} />
        <TextBetween margin={props.block ? '4px 0' : '8px 0'} title={{ text: 'มูลค่าใหม่' }} content={{ text: `${numeral(props.data.newCost).format('0,0.00')} บาท` }} />
        <TextBetween title={{ text: 'ผลต่าง' }} content={{ text: `${numeral(props.data.oldCost - props.data.newCost).format('0,0.00')} บาท`, bold: true }} />
      </Konsys.Div>
    </Konsys.Div>
  </Konsys.Div>
)

export const DebtList = props => (
  <Collapse style={{ margin: props.margin }} open={props.isOpen} text={props.title} onClick={() => props.setIsOpen(!props.isOpen)} fullHeight={props.fullHeight}>
    <Konsys.Div>
    {
      props.list.map((v, i) => (
        <Konsys.Div key={i} display='flex' margin={i !== v.length && '0 0 24px'}>
          <Konsys.P margin='0 8px 0 0'>{i + 1}.</Konsys.P>
          <DebtDetail block={props.block} data={v} />
        </Konsys.Div>
      ))
    }
    </Konsys.Div>
  </Collapse>
)
/* =============== end debt ================ */

export const SummaryPrice = (props) => {
  const vat = props.data?.vat?.value || 0
  const disabled = props.disabled || false

  const subtotal = props.data.total || 0
  const subtotalBeforeVat = subtotal / (1 + (vat / 100))
  const discount = props.data?.discount?.value || 0
  const shipping = props.data?.shipping?.value || 0
  const subtotalAfterDiscount = parseFloat(subtotal) - parseFloat(discount)
  const totalVat = parseFloat(subtotal) - parseFloat(subtotalBeforeVat)
  const total = parseFloat(subtotalAfterDiscount)
  const totalSummary = parseFloat(total) + parseFloat(shipping)

  return (
    <Konsys.Div margin={props.margin}>

      <SummaryPriceRow label='รวมมูลค่าก่อนภาษี' value={numeral(subtotalBeforeVat).format('0,0.00')} />
      <div className='mb-2 flex justify-between items-center'>
        <div className='flex items-center gap-x-2 shrink-0'>
          <p className='text-base font-extralight' style={{ color: theme.color.dark }}>จำนวนภาษีประเภท</p>
          <SelectAntd
            className='w-48'
            value={vat}
            onChange={value => props.data?.vat?.handleVatChange?.(value)}
            disabled={true}
          >
            <SelectAntd.Option value={0}>ไม่มีภาษี</SelectAntd.Option>
            <SelectAntd.Option value={7}>ภาษี 7%</SelectAntd.Option>
          </SelectAntd>
        </div>
        <p className='text-base font-bold' style={{ color: theme.color.dark }}>
          {numeral(totalVat).format('0,0.00')} บาท
        </p>
      </div>
      <SummaryPriceRow label='ยอดรวมมูลค่าหลังภาษี' value={numeral(subtotal).format('0,0.00')} />

      <Divider color={theme.color.black} margin='16px 0' />

      <SummaryPriceRow label='ส่วนลด' value={`- ${numeral(discount).format('0,0.00')}`} />
      <SummaryPriceRow label='ยอดรวมสุทธิ' value={numeral(subtotalAfterDiscount).format('0,0.00')} />

      <Divider color={theme.color.black} margin='16px 0' />

      <div className='mb-2 flex justify-between items-center' display='flex' justifyContent='space-between' alignItems='center' margin='0 0 8px'>
        <p className='text-base font-extralight' style={{ color: theme.color.dark }}>ค่าขนส่ง</p>
        <div>
          <Konsys.Input
            disabled={disabled}
            width='150px'
            type='text'
            rule={{ type: 'float' }}
            state='default'
            value={shipping}
            onChange={(e) => {
              if (props.data.shipping && props.data.shipping.customOnChange) {
                props.data.shipping.customOnChange(e.target.value)
              }
            }}
          />
          <Konsys.P margin='0 0 0 8px'>บาท</Konsys.P>
        </div>
      </div>

      <Divider color={theme.color.black} margin='16px 0' />

      <SummaryPriceRow label='ยอดชำระ' value={numeral(totalSummary).format('0,0.00')} />

      <Divider color={theme.color.black} margin='8px 0 2px' />
      <Divider color={theme.color.black} margin='0 0 16px' />
    </Konsys.Div>
  )
}

const SummaryPriceRow = ({ label, value }) => (
  <div className='mb-2 flex justify-between items-center'>
    <p className='text-base font-extralight' style={{ color: theme.color.dark }}>{label}</p>
    <p className='text-base font-bold' style={{ color: theme.color.dark }}>{value} บาท</p>
  </div>
)

export const RowSelect = props => (
  <RowSelectChildWrapper header={props.header}>
  {
    props.list.map((v, i) => (
      <Konsys.Div
        key={i}
        moreStyle={{ borderBottom: `1px solid ${theme.color.veryLightBlue}` }}
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        width='100%'
        padding='8px 16px'
      >
        <Konsys.Div display='flex' alignItems='flex-start'>
        {
          v.data.map((d, y) => (
            <SmallTextWithLabel {...d} key={y} margin={y === 1 ? '0 72px 0 0' : y !== props.list.length ? '0 16px 0 0' : '0'} />
          ))
        }
        </Konsys.Div>
        <Konsys.CheckboxAPS
          data={{ value: v.value }}
          onChange={(e) => {
            if (v.onChange) {
              v.onChange(e)
            }
          }}
          checked={v.checked}
        />
      </Konsys.Div>
    ))
  }
  </RowSelectChildWrapper>
)

export const GroupRowSelect = props => (
  <Konsys.Div>
    <RowSelect header list={props.list.header} />
    <Konsys.Div padding='0 0 0 56px' bgColor={theme.color.offWhite}>
      <RowSelect list={props.list.items} />
    </Konsys.Div>
  </Konsys.Div>
)

/* ===================== TABLE LIST ======================= */
export const TableRowData = props => (
  <Konsys.Div display='flex' margin={props.margin}>
  {
    props.data.map((v, i) => {
      const currentcolumnStyled = props.columnStyled[i]
      if (i === 0 && !props.isHeader) {
        return (
          <Konsys.Div
            margin={ _.isUndefined(currentcolumnStyled.margin) ? i === props.data.length - 1 ? '0' : '0 16px 0 0' : currentcolumnStyled.margin}
            display='flex'
            style={{
              width: _.isUndefined(currentcolumnStyled.width) ? 'auto' : currentcolumnStyled.width,
              flexGrow: i === 0 ? '1' : '0',
            }}
          >
            <Konsys.P margin='0 8px 0 0'>{props.no}.</Konsys.P>
            <Konsys.Div>
              <Konsys.P display='block'>{v.text}</Konsys.P>
              <Konsys.SmallText color={theme.color.heather} display='block' margin='6px 0 0'>{v.subText}</Konsys.SmallText>
              {
                !_.isUndefined(v.label)
                && <Konsys.Div margin='8px 0 0'>
                  {
                    v.label.withDevider && <Divider color={theme.color.paleBlue} margin='0 0 8px' />
                  }
                  <Konsys.SmallText color={v.label.color}>{v.label.text}</Konsys.SmallText>
                  {
                    v.label.withDevider && <Divider color={theme.color.paleBlue} margin='8px 0 0' />
                  }
                </Konsys.Div>
              }
              {
                !_.isUndefined(v.status)
                && <Konsys.Div margin='8px 0 0'>
                {
                  v.status.icon && <Konsys.Icon color={v.status.color} icon={v.status.icon} fontSize={theme.fonts.size.label} margin='0 8px 0 0'/>
                }
                  <Konsys.SmallText color={v.status.color}>สถานะ</Konsys.SmallText>
                  <Konsys.SmallText color={v.status.color} bold margin='0 0 0 8px'>{v.status.text}</Konsys.SmallText>
                </Konsys.Div>
              }
              {
                !_.isUndefined(v.status) && !_.isUndefined(v.status.subText)
                && <Konsys.SmallText color={theme.color.heather}>{v.status.subText}</Konsys.SmallText>
              }
            </Konsys.Div>
          </Konsys.Div>
        )
      }
      if (props.isHeader) {
        return (
          <Konsys.SmallText
            bold
            textAlign={_.isUndefined(v.textAlign) ? 'left' : v.textAlign}
            key={i}
            margin={ _.isUndefined(currentcolumnStyled.margin) ? i === props.data.length - 1 ? '0' : '0 16px 0 0' : currentcolumnStyled.margin}
            style={{
              width: _.isUndefined(currentcolumnStyled.width) ? 'auto' : currentcolumnStyled.width,
              flexGrow: i === 0 ? '1' : '0',
            }}
          >{v.text}</Konsys.SmallText>
        )
      }
      return (
        <Konsys.P
          bold={props.isHeader}
          textAlign={_.isUndefined(v.textAlign) ? 'left' : v.textAlign}
          key={i}
          margin={ _.isUndefined(currentcolumnStyled.margin) ? i === props.data.length - 1 ? '0' : '0 16px 0 0' : currentcolumnStyled.margin}
          style={{
            width: _.isUndefined(currentcolumnStyled.width) ? 'auto' : currentcolumnStyled.width,
          }}
        >{v.text}</Konsys.P>
      )
    })
  }
  </Konsys.Div>
)

export const TableList = props => (
  <Konsys.Div>
    <TableRowData key='header' isHeader data={props.headerData} columnStyled={props.columnStyled} />
    <Divider margin='8px 0 16px' />
    {
      props.data.map((v, i) => (
        <TableRowData margin={i === props.data.length - 1 ? '0' : '0 0 16px'} key={i} no={i + 1} data={v} columnStyled={props.columnStyled} />
      ))
    }
  </Konsys.Div>
)

export const ReplaceItem = props => (
  <Konsys.Div display='flex' alignItems='center'>
    <Konsys.Div moreStyle={{ flexGrow: 1 }}>
      <SelectWithLabel
        title={{ text: 'เลือกสินค้า', margin: '0 0 8px' }}
        width='100%'
        select={{
          style: {
            width: '100%',
          },
          options: props.data ? props.data.optionList : [],
          defaultValue: props.data && props.data.select && props.data.select.value,
          onChange: (value) => {
            if (props.data && props.data.select.onChange) { props.data.select.onChange(value) }
          },
        }}
      />
    </Konsys.Div>
    <InputWithLabel
      title={{ text: 'จำนวนชิ้น', margin: '0 0 8px' }}
      width='20%'
      margin='0 24px'
      input={{
        state: 'default',
        rule: { type: 'float' },
        width: '100%',
        value: props.data && props.data.quantity && props.data.quantity.value,
        onChange: (e) => {
          if (props.data && props.data.quantity.onChange) { props.data.quantity.onChange(e.target.value) }
        },
      }}
    />
    <InputWithLabel
      title={{ text: 'ราคา/ชิ้น', margin: '0 0 8px' }}
      width='30%'
      input={{
        state: 'default',
        rule: { type: 'float' },
        width: '100%',
        value: props.data && props.data.price && props.data.price.value,
        onChange: (e) => {
          if (props.data && props.data.price.onChange) { props.data.price.onChange(e.target.value) }
        },
      }}
    />
  </Konsys.Div>
)

// ------------------------------- TAE ------------------------------- //
export const Centerized = props => (
  <Konsys.Div width='100%' height='100%' display='flex' alignItems='center' justifyContent='center' flexDirection={props.direction || 'column'} margin={props.margin}>
  { props.children }
  </Konsys.Div>
)

// Props: margin, color, size
export const Loading = props => (
  <Spin style={{ margin: props.margin, ...props.style }} indicator={<Icon type="loading" style={{
    fontSize: props.size === 'extraSmall' ? theme.fonts.size.small : props.size === 'small' ? 20 : props.size === 'big' ? 48 : 28,
    color: props.color,
  }} spin />} />
)

// Props: color, size
export const LoadingPage = props => (
  <Centerized margin='40px 0 0'>
    <Spin style={{ marginBottom: 24 }} indicator={<Icon type="loading" style={{
      fontSize: props.size === 'small' ? 20 : props.size === 'normal' ? 28 : 48,
      color: props.color,
    }} spin />} />
    <Konsys.H4 bold>กำลังโหลด</Konsys.H4>
  </Centerized>
)

// Props: width, message
export const Error = props => (
  <Alert message={props.message} type="error" showIcon style={{ width: props.width || 'fit-content', ...props.style }} />
)

// Props: message
export const ErrorPage = props => (
  <Result
    status="error"
    title="เกิดข้อผิดพลาด"
    subTitle={props.message}
    extra={[
      <Button type="primary" key="console">
        กลับสู่หน้าหลัก
      </Button>,
    ]}
    style={props.style}
  />
)

export const Uploader = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState()
  const [images, setImages] = useState([])
  const filter = file => (_.isUndefined(file.url) && !_.isUndefined(file.originFileObj))

  return (
    <Konsys.Div className={props.className}>
      <ImagePopUp modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} images={images} index={0} />
      <Upload
        showUploadList={{
          showRemoveIcon: !props.disabled,
        }}
        disabled={props.disabled}
        customRequest={() => null}
        processData={false}
        fileList={props.data}
        accept={props.accept}
        onChange={(e) => {
          const verifiedFile = e.fileList.map(v => ({ ...v, isPassed: props.filter ? props.filter(v) : filter(v) }))
          if (props.isMultiple) props.onChange([...props.data, ..._.filter(verifiedFile, o => o.isPassed).map(v => v.originFileObj)])
          else props.onChange([..._.filter(verifiedFile, o => o.isPassed).map(v => v.originFileObj)])
        }}
        beforeUpload={() => false}
        multiple={props.isMultiple}
        onRemove={e => props.onChange(_.remove(_.cloneDeep(props.data), obj => obj.uid !== e.uid))}
        defaultFileList={_.size(props.data) > 0 && props.data.map(v => ({
          name: v.filename,
          url: v.url,
          uid: v.url,
        }))}
        onPreview={(e) => {
          if (e.url && !checkURLIsImage(e.url)) {
            window.open(e.url, '_blank')
          } else if ((e.url && checkURLIsImage(e.url)) || e.type.indexOf('image') > -1) {
            setImages([{ src: e.url || URL.createObjectURL(e) }])
            setModalIsOpen(true)
          }
        }}
        listType='picture'
      >
        <Konsys.Button inverse small text={props.buttonText || 'อัพโหลดไฟล์'} icon='far fa-file-upload' disabled={props.disabled} style={props.buttonStyle}/>
      </Upload>
    </Konsys.Div>
  )
}

export const UploadWithModal = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState()
  const [images, setImages] = useState([])
  return (
    <Konsys.Div>
      <ImagePopUp modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} images={images} index={0} />
      <Upload
        disabled={props.disabled}
        customRequest={props.customRequest}
        processData={props.processData}
        beforeUpload={props.beforeUpload}
        multiple={props.multiple}
        showUploadList={props.showUploadList}
        defaultFileList={props.defaultFileList}
        listType={props.listType}
        onPreview={(e) => {
          if (e.url && !checkURLIsImage(e.url)) {
            window.open(e.url, '_blank')
          } else if ((e.url && checkURLIsImage(e.url)) || e.type.indexOf('image') > -1) {
            setImages([{ src: e.url || URL.createObjectURL(e.originFileObj) }])
            setModalIsOpen(true)
          }
        }}
        onChange={props.onChange}
      >
        <Konsys.Button {...props.button} text='อัพโหลดไฟล์' icon='far fa-file-upload' disabled={props.disabled} />
      </Upload>
    </Konsys.Div>
  )
}

export const FileListWithModal = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState()
  // const [images, setImages] = useState(props?.files?.map(v => ({ src: v.url })))
  const [index, setIndex] = useState(0)
  return (
    <Konsys.Div>
      <ImagePopUp modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} images={props?.files?.map(v => ({ src: v.url }))} index={index} />
      {
        props?.files?.map((v, i) => (
          <PreviewImage key={i} src={v.url} onClick={() => {
            if (_.includes(['jpg', 'png', 'jpeg'], v.url.split('.')[v.url.split('.').length - 1])) {
              setIndex(i)
              setModalIsOpen(true)
            } else {
              window.open(v.url, '_blank')
            }
          }}/>
        ))
      }
    </Konsys.Div>
  )
}

export const DashedButton = props => (
  <Konsys.Button small style={{ borderStyle: 'dashed' }} onClick={e => props.onClick(e)} {...props}/>
)

export const Pagination = props => (
  <Konsys.Div display='flex' justifyContent={props.justify || 'center'} width='100%'>
    <PaginationAnt total={props.total} defaultCurrent={props.defaultValue} current={props.current || 1} pageSize={props.pageSize} onChange={e => props.onChange(e)} style={props.style}/>
  </Konsys.Div>
)

export const TimePicker = props => (
  <TimePickerAnt onChange={e => props.onChange(e)} defaultValue={props.defaultValue} style={props.style} {...props}/>
)

export const RangePicker = props => (
  <DatePickerAnt.RangePicker onChange={e => props.onChange(e)} defaultValue={props.defaultValue} style={props.style} {...props}/>
)

export const NotFound = props => (
  <Result
    status="warning"
    title={`ไม่พบข้อมูล${props.moduleName}`}
    extra={
      <Link to='/'>
        <Button type="primary" key="console">
          กลับหน้าหลัก
        </Button>
      </Link>
    }
  />
)

export const Modal = props => (
  <ModalCustomized
    {...props}
    onCancel={() => props.onAction('back')}
    footer={[
      <Konsys.Button key="back" onClick={() => props.onAction('back')} color={theme.color.error} {...props.cancelButton}/>,
      <Konsys.Button key="submit" onClick={() => props.onAction('submit')} color={theme.color.success} inverse {...props.okButton}/>,
    ]}
  >
    { props.children }
    <Konsys.P>{props.question}</Konsys.P>
  </ModalCustomized>
)

export const Remark = props => (
  <AlertCustomized
    message={props.message || 'หมายเหตุ'}
    description={props.description}
    type="info"
    showIcon={props.showIcon}
    {...props}
  />
)

export const CoverImage = props => (
  <img src={props.src} alt={props.alt} style={{ width: props.width, height: props.height, objectFit: 'cover' }}/>
)

// export const InputWithLabel = props => (
//   <Konsys.Div width={props.width || '100%'} margin={props.margin || '8px 0'}>
//     {props.icon && <Konsys.Icon icon={props.icon} color={props.title.color} margin='0 4px 0 0'/>}
//     <Konsys.SmallText bold color={props.title.color}>{props.title.text}</Konsys.SmallText>
//     <Input {...props.input} {...props}/>
//   </Konsys.Div>
// )

export const PaymentEvidence = props => (
  <Konsys.Div width='100%' height='100%' display='flex' flexDirection='row' margin='16px 0'>
    <Konsys.P>{props.index}.</Konsys.P>
    <Konsys.Div padding='0 0 0 16px' width='100%' height='100%' display='flex' alignItems='flex-start' justifyContent='flex-start' flexDirection='column'>
      <Konsys.P style={{ marginBottom: 5 }}>วันที่ทำรายการ : {moment.tz(props.date, 'Asia/Bangkok').format('DD/MM/YYYY HH:mm')}</Konsys.P>
      <Konsys.SmallText style={{ marginBottom: 5 }}>{props.info}</Konsys.SmallText>
      <CoverImage src={props.src} width={300} height={300}/>
    </Konsys.Div>
  </Konsys.Div>
)

export const PaymentEvidenceList = props => (
  <Collapse style={{ margin: props.margin }} open={props.isOpen} text={props.title} onClick={() => props.setIsOpen(!props.isOpen)} fullHeight={props.fullHeight}>
    <Konsys.Div>
    {
      props.list.map((v, i) => (
        <PaymentEvidence key={i} info={v.info} src={v.src} date={v.date} index={v.index}/>
      ))
    }
    </Konsys.Div>
  </Collapse>
)

export const Log = ({ data, index = 1, isPassed }) => (
  <Konsys.Button icon='fad fa-info-circle' onlyIcon inverse onClick={() => console.log(data)} style={{
    position: 'fixed', bottom: 48, right: (index * 48) + (index * 8), zIndex: 10, boxShadow: '5px 5px 15px 0px rgba(85,85,85,0.87)',
  }} />
)

export default TextWithIcon

// -------------------- Prop-types -------------------- //
Centerized.propTypes = {
  direction: PropTypes.string,
}

Loading.propTypes = {
  margin: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
}

LoadingPage.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
}

Error.propTypes = {
  width: PropTypes.string,
  message: PropTypes.string,
  style: PropTypes.object,
}

ErrorPage.propTypes = {
  message: PropTypes.string,
  style: PropTypes.object,
}

Uploader.propTypes = {
  disabled: PropTypes.bool,
  data: PropTypes.object,
  accept: PropTypes.string,
  filter: PropTypes.func,
  onChange: PropTypes.func,
  buttonStyle: PropTypes.object,
}

DashedButton.propTypes = {
  disabled: PropTypes.string,
  style: PropTypes.object,
}

Pagination.propTypes = {
  justify: PropTypes.string,
  total: PropTypes.number,
  defaultValue: PropTypes.number,
  current: PropTypes.number,
  pageSize: PropTypes.number,
  onChange: PropTypes.func,
  style: PropTypes.object,
}

TimePicker.propTypes = {
  onChange: PropTypes.func,
  defaultValue: PropTypes.object,
  style: PropTypes.object,
}

RangePicker.propTypes = {
  onChange: PropTypes.func,
  defaultValue: PropTypes.object,
  style: PropTypes.object,
}

Modal.propTypes = {
  onAction: PropTypes.func,
  cancelButton: PropTypes.object,
  okButton: PropTypes.object,
  visible: PropTypes.bool,
  title: PropTypes.string,
  question: PropTypes.string,
}

Remark.propTypes = {
  message: PropTypes.string,
  description: PropTypes.string,
}

CoverImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}

PaymentEvidence.propTypes = {
  src: PropTypes.string,
  info: PropTypes.string,
  index: PropTypes.number,
  date: PropTypes.object,
}
